import {Component, inject, OnInit, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SharedModule} from '../../../../core/modules/shared.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {Task, TaskGroup, TaskGroupService} from '../../../../core/services/taskGroup.service';
import {EditTaskGroupModal} from './edit-modal/edit-task-group.modal';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-task-group',
  templateUrl: './taskGroup.component.html',
  styleUrls: ['./taskGroup.component.scss'],
  imports: [SharedModule, PagesContainerComponent],
  providers: [TaskGroupService]
})
export class TaskGroupComponent implements OnInit {
  private dialog = inject(MatDialog);
  private taskGroupService = inject(TaskGroupService);
  private router = inject(Router);
  taskGroups = signal<TaskGroup[]>([]);
  search = signal('');
  ngOnInit() {
    this.getTaskGroups();
  }

  handleSearch(value: string) {
    this.search.set(value);
    this.getTaskGroups();
  }

  getTaskGroups() {
    this.taskGroupService.getTaskGroup(this.search()).subscribe(response => {
      this.taskGroups.set(response);
    });
  }

  addTaskGroup() {
    const dialogRef = this.dialog.open<EditTaskGroupModal, object, Pick<TaskGroup, 'title' | 'countryId' | 'cityId' | 'organizationId'>>(EditTaskGroupModal, {
      width: '400px',
      data: {type: 'group', action: 'new'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.taskGroupService.addTaskGroup(result).subscribe(() => this.getTaskGroups());
      }
    });
  }

  editTaskGroup(group: TaskGroup) {
    const dialogRef = this.dialog.open<EditTaskGroupModal, object, Pick<TaskGroup, 'title' | 'countryId' | 'cityId' | 'organizationId'>>(EditTaskGroupModal, {
      width: '400px',
      data: {type: 'group', action: 'edit', title: group.title,
        countryId: group.countryId, cityId: group.cityId, organizationId: group.organizationId}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.taskGroupService.addTaskGroup({...result, id: group.id}).subscribe(() => this.getTaskGroups());
      }
    });
  }

  addTask(groupId: number) {
     this.router.navigate([ '/pages/tasks/detail' ] , {queryParams: {groupId: groupId}});
    // const dialogRef = this.dialog.open<EditTaskGroupModal, object, Pick<Task, 'title' | 'description' | 'deadline'>>(EditTaskGroupModal, {
    //   width: '700px',
    //   data: {type: 'task', action: 'new'}
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.taskGroupService.addTask({...result, taskGroupId: groupId}).subscribe(() => this.getTaskGroups());
    //   }
    // });
  }

  deleteTaskGroup(group: TaskGroup) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.taskGroupService.deleteTaskGroup(group.id).subscribe(() => this.getTaskGroups());
      }
    });
  }

  editTask(task: Task, groupId: number) {
     this.router.navigate([ '/pages/tasks/detail' ] , {queryParams: {id: task.id}});
    // const dialogRef = this.dialog.open<EditTaskGroupModal, object, Pick<Task, 'title' | 'description' | 'deadline'>>(EditTaskGroupModal, {
    //   width: '700px',
    //   data: {type: 'task', action: 'edit', title: task.title, description: task.description, deadline: task.deadline}
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.taskGroupService.addTask({...result, id: task.id, taskGroupId: groupId})
    //       .subscribe(() => this.getTaskGroups());
    //   }
    // });
  }

}
